module.exports = __webpack_public_path__ + "img/preco_agregado.e42b5c29.png";